module.exports = __webpack_public_path__ + "img/HERO-head-02-kasor.01a58218.png";